import React from 'react';
import { Box, Paper, Typography, Button } from '@mui/material';
import { ReplayOutlined, RoomService } from '@mui/icons-material';

const ServiceNotice = ({ isVisible }) => {

    return (
        <>
            <Paper
                elevation={8}
                sx={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    zIndex: 9999,
                    backgroundColor: '#fff',
                    borderTop: '3px solid #AF3241',
                    boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
                    display: isVisible ? 'block' : 'none',
                }}
            >
                <Box
                    sx={{
                        maxWidth: '1200px',
                        margin: '0 auto',
                        padding: { xs: '14px 20px', sm: '16px 32px' },
                        display: 'flex',
                        alignItems: 'center',
                        gap: 3,
                        flexWrap: { xs: 'wrap', lg: 'nowrap' },
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1 }}>
                        <RoomService sx={{ color: '#AF3241', fontSize: 28, flexShrink: 0,  marginBottom: 1.5, }} />
                        <Box sx={{ flex: 1 }}>
                            <Typography
                                variant="h6"
                                sx={{
                                    fontSize: '16px',
                                    fontWeight: 600,
                                    color: '#333',
                                    mb: 0.5,
                                }}
                            >
                                Service Unavailable
                            </Typography>
                            <Typography
                                variant="body2"
                                sx={{
                                    fontSize: '13px',
                                    lineHeight: 1.6,
                                    color: '#666',
                                    mb: 1.5,
                                }}
                            >
                                The service is currently unavailable.
                                We are aware of the issue and are working to restore service as quickly as possible.
                                Try signing in again later.
                            </Typography>
                        </Box>
                    </Box>

                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 2,
                            flexDirection: { xs: 'column', sm: 'row' },
                            flexShrink: 0,
                            width: { xs: '100%', lg: 'auto' },
                            alignSelf: 'center',
                            marginBottom: 1,
                        }}
                    >
                        <Button
                            variant="text"
                            onClick={() => window.location.reload()}
                            startIcon={<ReplayOutlined />}
                            sx={{
                                color: '#666',
                                padding: '0px 16px',
                                fontSize: '13px',
                                fontWeight: 500,
                                textTransform: 'none',
                                whiteSpace: 'nowrap',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                '& .MuiButton-startIcon': {
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    marginTop: 0,
                                    marginBottom: 0,
                                },
                                '&:hover': {
                                    backgroundColor: '#f5f5f5',
                                },
                            }}
                        >
                            Reload
                        </Button>
                    </Box>
                </Box>
            </Paper>
        </>
    );
};

export default ServiceNotice;
